import { axiosInstance } from "../helpers/axios/config";
import * as PICKER_END_POINTS from "../constants/endPoints/picker";
import * as method from "../constants/requestMethods";

export const getAllPickers = (params) => {
  return axiosInstance({
    url: PICKER_END_POINTS.getAllPickers,
    method: method.GET,
    params,
  });
};

export const getPickerById = (pickerId) => {
  return axiosInstance({
    url: PICKER_END_POINTS.getPickerById.replace(":pickerId", pickerId),
    method: method.GET,
  });
};

export const createPicker = (data) => {
  return axiosInstance({
    url: PICKER_END_POINTS.createPicker,
    method: method.POST,
    data,
  });
};

export const editPicker = (pickerId, data) => {
  return axiosInstance({
    url: PICKER_END_POINTS.editPicker.replace(":pickerId", pickerId),
    method: method.PUT,
    data,
  });
};

export const pickerLogin = (data) => {
  return axiosInstance({
    url: PICKER_END_POINTS.pickerLogin,
    method: method.POST,
    data,
  });
};
